import { CURRENT_YEAR, CURRENT_MONTH } from '@/config/date'

import syncQuery from '@/mixins/syncUrlQuery'
import monthArray from '@/mixins/monthArray'

export default {
  mixins: [syncQuery],
  data() {
    return {
      month: '',
      year: '',
    }
  },
  methods: {
    getDateLabel() {
      // Get query parameters value or current date
      const m = this.month || CURRENT_MONTH

      const year = this.year || CURRENT_YEAR
      const month = monthArray.find((month) => month.value === m)

      return { month, year }
    },
  },
  mounted() {
    this.syncQuery(['month', 'year'])
  },
}
